/**
 * Adds the scheme to an URL that doesn't have it.
 *
 * Useful for images urls in the HTML head, when the API returns a URL without the scheme.
 *
 * @example
 * addSchemeToUrl('//assets.change.org/images/default-petition-darker.gif') => 'https://assets.change.org/images/default-petition-darker.gif'
 */
export function addSchemeToUrl(url: string | null | undefined): string | null {
	if (!url) return null;
	if (url.startsWith('//')) return `https:${url}`;
	return url;
}
